import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-request-layout',
  templateUrl: './request-layout.component.html',
  styleUrls: ['./request-layout.component.css']
})
export class RequestLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
